import { render, staticRenderFns } from "./IOSTimeGrid.vue?vue&type=template&id=5b65052a"
import script from "./IOSTimeGrid.vue?vue&type=script&lang=js"
export * from "./IOSTimeGrid.vue?vue&type=script&lang=js"
import style0 from "./IOSTimeGrid.vue?vue&type=style&index=0&id=5b65052a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports